module.exports = __webpack_public_path__ + "media/images/samples/1280x768/11-40ef3afa068719bcde38b7aff7c1d692.jpg";